import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useLogoutMutation } from "@/modules/auth/services/socialAuthClient";
import { useCreatorAnalytics } from "@/lib/analytics";
import { shutdownIntercom } from "@/lib/intercom";
import { authService } from "@/lib/authService";

export const useLogout = (creator?: any, redirectTo = "/login") => {
  const queryClient = useQueryClient();
  const logoutMutation = useLogoutMutation();
  const { trackLogout } = useCreatorAnalytics();

  const logout = useCallback(async () => {
    try {
      trackLogout(undefined, creator);
      shutdownIntercom();
      authService.clearToken();

      // Clear cookie on the backend (cross-origin)
      await logoutMutation.mutateAsync();
    } catch {
      // Backend call may fail — that's fine, we clear locally below
    }

    try {
      // Clear cookie on the same origin via Next.js API route
      // This guarantees the cookie is removed even if the cross-origin
      // Set-Cookie header was ignored by the browser
      await fetch("/api/auth/logout", { method: "POST" });
    } catch {
      // Best-effort
    }

    queryClient.clear();
    window.location.href = redirectTo;
  }, [logoutMutation, queryClient, trackLogout, creator, redirectTo]);

  return {
    logout,
    isLoading: logoutMutation.isPending,
    error: logoutMutation.error,
  };
};
